export default state => state.loyalty.isPriority;
